import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import Modal from "../modal";

import "./errorModalStyles.css";

const ErrorModal = ({
  message = "An unexpected error has occurred",
  displayModal,
  setDisplayModal,
}) => {
  const getTitle = () => <span className="error-modal-title">Error</span>;

  const getBodyContent = () => (
    <Container className="error-modal">
      <Row className="align-items-center mb-1">
        <Col md={12} className="text-name text-center">
          {message}
        </Col>
      </Row>
    </Container>
  );

  return (
    <Modal
      size="md"
      title={getTitle()}
      bodyContent={getBodyContent()}
      showFooter={false}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
    />
  );
};

export default ErrorModal;
